import { RestService } from './_rest.service'
import { REST_API_END_POINTS } from './constants'

export class SupportPackageService extends RestService {
    constructor(url?: string) {
        url ? super(url) : super(REST_API_END_POINTS.SUPPORT_PACKAGES)
    }
}
